import http from "./Axios-Config";

export const generateSupervisorCode = async () => {
  return await http.post(`supervisors/code`);
};
